import { render, staticRenderFns } from "./AddPersonnel.vue?vue&type=template&id=6f07cc40&scoped=true"
import script from "./AddPersonnel.vue?vue&type=script&lang=js"
export * from "./AddPersonnel.vue?vue&type=script&lang=js"
import style0 from "./AddPersonnel.vue?vue&type=style&index=0&id=6f07cc40&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f07cc40",
  null
  
)

export default component.exports